import formatDistanceToNowStrict from "date-fns/formatDistanceToNowStrict";
import format from "date-fns/format";
import { toDate } from 'date-fns-tz'

function getDate(timestamp: number|string) {
    const dateNumber = Number(timestamp);
    if (isNaN(dateNumber)) {
        // parses date to timezone 'America/Denver' so that it accounts for DST and ISO dates without offset included
        return toDate(timestamp, { timeZone: 'America/Denver' });
    } else {
        return new Date(dateNumber)
    }
}

export function calculateDate(date: string, type: string, dateFormat: string) {
    try {
        if (!date) {
            return "";
        }
        else if (type === "timeAgo") {
            const formattedPostAge = formatDistanceToNowStrict(getDate(date), { addSuffix: true });
            return formattedPostAge;
        } else {
            const formattedDate = format(getDate(date), dateFormat);
            return formattedDate;
        }
    } catch (err) {
        console.warn(`Error while parsing date ${date}`);
        return "";
    }
}
